__turbopack_context__.v({
  "closeIcon": "CustomDropDown-module__YwczJa__closeIcon",
  "customDropDown": "CustomDropDown-module__YwczJa__customDropDown",
  "customDropDownSection": "CustomDropDown-module__YwczJa__customDropDownSection",
  "heading": "CustomDropDown-module__YwczJa__heading",
  "loading": "CustomDropDown-module__YwczJa__loading",
  "noResult": "CustomDropDown-module__YwczJa__noResult",
  "search": "CustomDropDown-module__YwczJa__search",
  "title": "CustomDropDown-module__YwczJa__title",
});
